import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-anchor', 'top', 'Перейти в начало страницы');
Labels.set('ui-anchor', 'bottom', 'Перейти в конец страницы');
Labels.set('ui-anchor', 'left', 'Перейти влево');
Labels.set('ui-anchor', 'right', 'Перейти вправо');
